var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 56,
    viewBox: "0 0 193 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.456 0H9.54395C4.27297 0 0 4.33939 0 9.6923V46.3077C0 51.6606 4.27297 56 9.54395 56H183.456C188.727 56 193 51.6606 193 46.3077V9.6923C193 4.33939 188.727 0 183.456 0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2534 14.5503C70.2534 15.7277 69.9635 16.758 69.2389 17.4939C68.3694 18.3769 67.3549 18.8185 66.0505 18.8185C64.7462 18.8185 63.7317 18.3769 62.8622 17.4939C61.9926 16.6108 61.5579 15.5806 61.5579 14.2559C61.5579 12.9313 61.9926 11.9011 62.8622 11.018C63.7317 10.1349 64.7462 9.69336 66.0505 9.69336C66.6301 9.69336 67.21 9.84055 67.7897 10.1349C68.3694 10.4293 68.8042 10.7236 69.094 11.1652L68.3694 11.9011C67.7897 11.1652 67.0651 10.8708 66.0505 10.8708C65.1809 10.8708 64.3114 11.1652 63.7317 11.9011C63.0071 12.4898 62.7172 13.3729 62.7172 14.4031C62.7172 15.4334 63.0071 16.3164 63.7317 16.9052C64.4563 17.4939 65.1809 17.9354 66.0505 17.9354C67.0651 17.9354 67.7897 17.6411 68.5143 16.9052C68.9491 16.4636 69.2389 15.8749 69.2389 15.139H66.0505V14.1087H70.2534V14.5503Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.168205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9198 10.8696H73.0069V13.666H76.63V14.6963H73.0069V17.4927H76.9198V18.6701H71.8474V9.83936H76.9198V10.8696Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.168205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7038 18.6701H80.5444V10.8696H78.0806V9.83936H84.1675V10.8696H81.7038V18.6701Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.168205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3702 18.6701V9.83936H89.5296V18.6701H88.3702Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.168205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4571 18.6701H93.2977V10.8696H90.8339V9.83936H96.7759V10.8696H94.3122V18.6701H94.4571Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.168205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.225 17.4929C107.355 18.3759 106.341 18.8175 105.037 18.8175C103.732 18.8175 102.718 18.3759 101.848 17.4929C100.979 16.6098 100.544 15.5796 100.544 14.2549C100.544 12.9303 100.979 11.9001 101.848 11.017C102.718 10.1339 103.732 9.69238 105.037 9.69238C106.341 9.69238 107.355 10.1339 108.225 11.017C109.094 11.9001 109.529 12.9303 109.529 14.2549C109.529 15.5796 109.094 16.6098 108.225 17.4929ZM102.718 16.757C103.297 17.3457 104.167 17.7872 105.037 17.7872C105.906 17.7872 106.776 17.4929 107.355 16.757C107.935 16.1683 108.37 15.2852 108.37 14.2549C108.37 13.2247 108.08 12.3416 107.355 11.7529C106.776 11.1642 105.906 10.7226 105.037 10.7226C104.167 10.7226 103.297 11.017 102.718 11.7529C102.138 12.3416 101.703 13.2247 101.703 14.2549C101.703 15.2852 101.993 16.1683 102.718 16.757Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.168205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.123 18.6701V9.83936H112.427L116.63 16.7568V14.9906V9.83936H117.79V18.6701H116.63L112.137 11.4583V13.2245V18.6701H111.123Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.168205,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3203 30.9264C93.1916 30.9264 90.7148 33.3094 90.7148 36.619C90.7148 39.7963 93.1916 42.3117 96.3203 42.3117C99.4491 42.3117 101.926 39.9287 101.926 36.619C101.926 33.1769 99.4491 30.9264 96.3203 30.9264ZM96.3203 39.9288C94.6257 39.9288 93.1916 38.4724 93.1916 36.4867C93.1916 34.5008 94.6257 33.0446 96.3203 33.0446C98.015 33.0446 99.4491 34.3685 99.4491 36.4867C99.4491 38.4724 98.015 39.9288 96.3203 39.9288ZM84.1968 30.9264C81.0681 30.9264 78.5912 33.3094 78.5912 36.619C78.5912 39.7963 81.0681 42.3117 84.1968 42.3117C87.3254 42.3117 89.8022 39.9287 89.8022 36.619C89.8022 33.1769 87.3254 30.9264 84.1968 30.9264ZM84.1968 39.9288C82.502 39.9288 81.0681 38.4724 81.0681 36.4867C81.0681 34.5008 82.502 33.0446 84.1968 33.0446C85.8914 33.0446 87.3254 34.3685 87.3254 36.4867C87.3254 38.4724 85.8914 39.9288 84.1968 39.9288ZM69.7266 32.6474V35.0303H75.3322C75.2018 36.3542 74.6803 37.4133 74.0286 38.0753C73.2464 38.8697 71.9428 39.7963 69.7266 39.7963C66.2069 39.7963 63.5997 37.0162 63.5997 33.4417C63.5997 29.8673 66.3372 27.0871 69.7266 27.0871C71.5517 27.0871 72.9857 27.8814 74.0286 28.8082L75.7232 27.0871C74.2893 25.7632 72.4643 24.7041 69.857 24.7041C65.164 24.7041 61.1228 28.6757 61.1228 33.4417C61.1228 38.2076 65.164 42.1793 69.857 42.1793C72.4643 42.1793 74.2893 41.3849 75.8537 39.664C77.418 38.0753 77.9394 35.8246 77.9394 34.1037C77.9394 33.5742 77.9394 33.0446 77.809 32.6474H69.7266ZM128.911 34.5008C128.389 33.1769 127.086 30.9264 124.218 30.9264C121.35 30.9264 119.003 33.1769 119.003 36.619C119.003 39.7963 121.35 42.3117 124.478 42.3117C126.955 42.3117 128.52 40.7231 129.041 39.7963L127.216 38.4724C126.564 39.3992 125.782 40.061 124.478 40.061C123.175 40.061 122.393 39.5315 121.741 38.3401L129.171 35.1628L128.911 34.5008ZM121.35 36.3542C121.35 34.236 123.044 33.0446 124.218 33.0446C125.13 33.0446 126.043 33.5742 126.304 34.236L121.35 36.3542ZM115.223 41.7822H117.7V25.2337H115.223V41.7822ZM111.312 32.1178C110.66 31.456 109.617 30.7939 108.314 30.7939C105.576 30.7939 102.969 33.3094 102.969 36.4867C102.969 39.664 105.446 42.0469 108.314 42.0469C109.617 42.0469 110.66 41.3849 111.182 40.7231H111.312V41.5174C111.312 43.6356 110.139 44.827 108.314 44.827C106.88 44.827 105.837 43.7679 105.576 42.8413L103.49 43.7679C104.142 45.2242 105.706 47.0777 108.444 47.0777C111.312 47.0777 113.658 45.3566 113.658 41.2526V31.1912H111.312V32.1178ZM108.444 39.9288C106.749 39.9288 105.315 38.4724 105.315 36.4867C105.315 34.5008 106.749 33.0446 108.444 33.0446C110.139 33.0446 111.442 34.5008 111.442 36.4867C111.442 38.4724 110.139 39.9288 108.444 39.9288ZM140.252 25.2337H134.386V41.7822H136.863V35.5599H140.252C142.99 35.5599 145.597 33.5742 145.597 30.3969C145.597 27.2196 142.99 25.2337 140.252 25.2337ZM140.383 33.1769H136.863V27.4843H140.383C142.208 27.4843 143.25 29.073 143.25 30.2644C143.12 31.7207 142.077 33.1769 140.383 33.1769ZM155.374 30.7939C153.549 30.7939 151.724 31.5883 151.072 33.3094L153.288 34.236C153.81 33.3094 154.592 33.0446 155.504 33.0446C156.808 33.0446 157.981 33.8389 158.112 35.1628V35.2951C157.721 35.0303 156.678 34.6333 155.635 34.6333C153.288 34.6333 150.942 35.9571 150.942 38.3401C150.942 40.5906 152.897 42.0469 154.983 42.0469C156.678 42.0469 157.46 41.2526 158.112 40.4583H158.242V41.7822H160.589V35.4276C160.328 32.5151 158.112 30.7939 155.374 30.7939ZM155.113 39.9288C154.331 39.9288 153.158 39.5315 153.158 38.4724C153.158 37.1485 154.592 36.7515 155.765 36.7515C156.808 36.7515 157.329 37.0162 157.981 37.281C157.721 38.8696 156.417 39.9288 155.113 39.9288ZM168.801 31.1912L166.064 38.3401H165.933L163.065 31.1912H160.458L164.76 41.2526L162.283 46.8129H164.76L171.408 31.1912H168.801ZM146.901 41.7822H149.377V25.2337H146.901V41.7822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1862 12.0952C16.8003 12.4871 16.543 13.1403 16.543 13.9241V42.794C16.543 43.5777 16.8003 44.231 17.1862 44.6228L17.3149 44.7535L33.2654 28.555V28.4243V28.2937L17.1862 12.0952Z",
    fill: "url(#paint0_linear_111_45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5392 34.0417L33.2653 28.6859V28.4246V28.294L38.5392 22.938L38.6679 23.0687L44.9709 26.7264C46.7718 27.7715 46.7718 29.4697 44.9709 30.5148L38.5392 34.0417Z",
    fill: "url(#paint1_linear_111_45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6684 33.9114L33.266 28.4248L17.1867 44.7539C17.8299 45.407 18.7303 45.407 19.888 44.8844L38.6684 33.9114Z",
    fill: "url(#paint2_linear_111_45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6684 22.9384L19.888 12.0959C18.7303 11.4428 17.8299 11.5734 17.1867 12.2266L33.266 28.425L38.6684 22.9384Z",
    fill: "url(#paint3_linear_111_45)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.5399 33.7822L19.888 44.4942C18.8589 45.1473 17.9585 45.0167 17.3154 44.4942L17.1867 44.6247L17.3154 44.7554C17.9585 45.278 18.8589 45.4085 19.888 44.7554L38.5399 33.7822Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M17.1871 44.4938C16.8012 44.102 16.6726 43.4489 16.6726 42.665V42.7956C16.6726 43.5794 16.9299 44.2327 17.3157 44.6245V44.4938H17.1871Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M44.9709 30.123L38.5392 33.7807L38.6679 33.9114L44.9709 30.2536C45.8713 29.731 46.2573 29.0779 46.2573 28.4248C46.2573 29.0779 45.7427 29.6005 44.9709 30.123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M19.8876 12.226L44.9711 26.7262C45.7429 27.2488 46.2574 27.7713 46.2574 28.4244C46.2574 27.7713 45.8716 27.1181 44.9711 26.5957L19.8876 12.0954C18.0867 11.0503 16.6718 11.9647 16.6718 14.0549V14.1855C16.6718 12.0954 18.0867 11.1809 19.8876 12.226Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111_45",
    x1: 31.85,
    y1: 13.6755,
    x2: 9.92928,
    y2: 35.2608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_111_45",
    x1: 47.3305,
    y1: 28.4265,
    x2: 16.2052,
    y2: 28.4265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_111_45",
    x1: 35.7446,
    y1: 31.4243,
    x2: 6.01838,
    y2: 60.6955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_111_45",
    x1: 13.1956,
    y1: 2.52863,
    x2: 26.4698,
    y2: 15.5994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 193,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleplay);
export default __webpack_public_path__ + "static/media/googleplay.e0de91131f7207d6ee929b0772f833ed.svg";
export { ForwardRef as ReactComponent };